import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=1b541585&lang=pug&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=1b541585&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports